var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewPrepIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.192 8.923h2.164m-2.164 1.73h2.164m-2.164 1.732h2.164m1.73.432h1.299c.717 0 1.298-.58 1.298-1.298V5.524c0-.655-.488-1.21-1.14-1.265a27.876 27.876 0 0 0-.648-.046m-3.347 0a1.31 1.31 0 0 0-.058.383c0 .24.194.433.433.433h2.596a.433.433 0 0 0 .433-.433c0-.133-.02-.262-.057-.383m-3.347 0c.163-.53.657-.915 1.24-.915h.866c.584 0 1.077.385 1.24.915m-3.346 0c-.217.013-.433.029-.648.046-.653.055-1.14.61-1.14 1.265V6.76m0 0H3.813a.649.649 0 0 0-.65.649v6.49c0 .359.291.65.65.65h5.625a.65.65 0 0 0 .649-.65V7.41a.65.65 0 0 0-.65-.65H5.76zm-.866 2.163H4.9v.004h-.005v-.004zm0 1.73H4.9v.005h-.005v-.004zm0 1.732H4.9v.004h-.005v-.004z",
    stroke: "#344054",
    strokeWidth: 0.865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#344054",
    strokeWidth: 0.577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.09 15.813l-.282.985-.282-.985a1.558 1.558 0 0 0-1.07-1.07l-.985-.282.985-.281a1.557 1.557 0 0 0 1.07-1.07l.282-.985.281.985c.148.518.553.922 1.07 1.07l.985.281-.985.282a1.558 1.558 0 0 0-1.07 1.07zm2.923-2.489l-.09.359-.09-.359a1.168 1.168 0 0 0-.85-.85l-.358-.09.358-.09c.419-.104.746-.43.85-.85l.09-.358.09.359c.104.418.431.745.85.85l.358.09-.358.09a1.169 1.169 0 0 0-.85.85zm-.473 4.103l-.136.41-.137-.41a.78.78 0 0 0-.492-.493l-.41-.136.41-.136a.779.779 0 0 0 .492-.493l.137-.41.136.41c.078.232.26.415.493.492l.41.137-.41.136a.78.78 0 0 0-.493.493z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10.692 10.308)",
    d: "M0 0h8.308v8.308H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewPrepIcon);
export default __webpack_public_path__ + "static/media/interviewPrepIcon.84cde5fbf198fd117302d8a1d0e846c5.svg";
export { ForwardRef as ReactComponent };